module.exports = "https://r.nearpod.com/assets/media/image/mcq_icon-small-23ddc3fa4c9a9709efb661990c46d432.svg";